export default {
  namespaced: true,
  state: {
    activeIndex: null,
    list: [
      {
        lable: "首页",
        path: "/home",
        reg: /^\/home/
      },
      {
        lable: "资讯动态",
        path: "/newsUpdates",
        reg: /^\/newsUpdates/
      },
      {
        lable: "通知公告",
        path: "/bannerNews",
        reg: /^\/bannerNews/
      },
      // {
      //   lable: "网上商城",
      //   path: "/shop",
      //   reg: /^\/shop/,
      //   outerPath: 'http://mall.zyzhjcxgpt.com/',
      // },
      // {
      //   lable: "CA办理",
      //   path: "/Comprehensive",
      //   reg: /^\/Comprehensive/,
      //   // outerPath: 'https://demo.itruscloud.com/certsaas_cloud_portal/#/createOrder?productCode=CERT652918',
      //   outerPath: 'https://www.itruscloud.com/certsaas_cloud_portal/#/home/projectDetail/zyzhjcxgpt',
      // },
      {
        lable: "关于我们",
        path: "/abstract",
        reg: /^\/abstract/
      },
      // {
      //   lable: "帮助中心",
      //   path: "/help",
      //   reg: /^\/help/
      // },
      // {
      //   lable: "综合项目管理平台",
      //   path: "/Comprehensive",
      //   reg: /^\/Comprehensive/,
      //   outerPath: 'http://www.zyzhjcxgpt.com:8000/i8/web',
      // },
      // {
      //   lable: "中标贷",
      //   path: "/shop",
      //   reg: /^\/shop/,
      //   outerPath: 'https://www.cmbchina.com/',
      // },
      // {
      //   lable: "采购公告",
      //   path: "/purchase",
      //   reg: /^\/purchase/
      // },
      // {
      //   lable: "更正公告",
      //   path: "/correct",
      //   reg: /^\/correct/
      // },
      // {
      //   lable: "结果公告",
      //   path: "/result",
      //   reg: /^\/result/
      // },
      // {
      //   lable: "公司简介",
      //   path: "/abstract",
      //   reg: /^\/abstract/
      // }
    ]
  },
  mutations: {
    updateIndex(state, activeIndex) {
      state.activeIndex = activeIndex;
    }
  },
  actions: {
    updateIndex({ state, commit }, route) {
      let item = state.list.find((item) => {
        return item.reg.test(route.path)
      });
      if (item) {
        commit('updateIndex', item.path);
        return;
      }
      commit('updateIndex', null)
    }
  }
}